import { emphasize } from '@material-ui/core/styles/colorManipulator';

const primaryStyle = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    fontSize: 14,
    fontFamily: `"LLCircularWeb-Book", "Helvetica Neue", Helvetica, Arial, sans-serif`,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: `${theme.spacing(1 / 2)}px ${theme.spacing(1 / 4)}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 14,
    width: '95%',
    padding: '0 4px',
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 14,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
    width: 'fit-content',
    minWidth: '200px',
    borderRadius: '0px 0px 16px 16px',
    overflow: 'hidden',
  },
  divider: {
    height: theme.spacing(2),
  },
  menuItem: {
    fontSize: 14,
    fontFamily: `"LLCircularWeb-Book", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    borderBottom: '1px solid #CACDD2',
  },
});

export default primaryStyle;
